import { render, staticRenderFns } from "./DeletePropertyGroup.vue?vue&type=template&id=b5b0e01a"
import script from "./DeletePropertyGroup.vue?vue&type=script&lang=js"
export * from "./DeletePropertyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports